<template>
  <div>
    <List
    theme="dark"
    :items="documentItems"
    title="Документы"
    />
  </div>
</template>

<script>
import {List } from 'sputnik-ui/src/index';

export default {
  name: 'DocumentsPage',
  components: {
    List
  },
  data() {
    return {
      documentItems: [
        { text: 'Политика обработки персональных данных', onClick: () => window.open('/docs/Политика_обработки_персональных_данных.pdf', '_blank') },
        { text: 'Что такое cookie', onClick: () => window.open('/docs/Что_такое_cookie.pdf', '_blank') },
        { text: 'Цели обработки персональных данных', onClick: () => window.open('/docs/Цели_обработки_персональных_данных.pdf', '_blank') },
        { text: 'Кодекс деловой этики поставщика', onClick: () => window.open('/docs/Кодекс_деловой_этики_поставщика_2024.pdf', '_blank')},
        { text: 'Антикоррупционная политика', onClick: () => window.open('/docs/Антикоррупционная_политика_2024.pdf', '_blank') },
        { text: 'Пользовательское соглашение', onClick: () => window.open('/docs/Пользовательское_соглашение_2026.pdf', '_blank') },
      ]
    }
  },
};
</script>
